<template>
  <bk-page class="personalPage" :loading="loadView==='view'" pageType="navPage" :navBarInfo="navBarInfo">
		<bk-view class="view-form-main">
			<bk-form ref="bkForm" v-model="formData" :formConfig="formConfig" >
				<template #slot-email="{row, column}">
					<bk-view class="view-email-main">
						<van-field
							:label="$bk_lang[column.langCode]"
							v-model="row.email"
							readonly
							label-align="top"
						/>
						<bk-view class="view-change-main" @click="setShowPage('updateEmail')">
							<bk-view class="view-shadow"></bk-view>
							<bk-lang code="userInfo_personal_change"></bk-lang>
						</bk-view>
					</bk-view>
				</template>
			</bk-form>
		</bk-view>

		<bk-view class="view-footer-main">
			<bk-button size="full" :loading="loadView==='save'" langCode="userInfo_personal_save" @click="handleSave"></bk-button>
		</bk-view>

		<transition name="rightFadeIn">
      <component :is="showPage"  :curRows="formData" @close="setShowPage()" @reload="reloadData" />
    </transition>

	</bk-page>
</template>

<script>
	import { authReq, baseReq } from '@/reqService';
	import updateEmail from './updateEmail/updateEmail.vue';


	export default {
		name: 'personal',
		components:{ updateEmail },
		data (){
			const { genderList } = this.$bk_Global.baseConstantInfo; 

			return {
				genderList,
				navBarInfo: {
					langCode_title:'userInfo_personal_title',
					backFlag: true,
				},
				loadView:'save',
				formData:{},
				dictInfo:{},
				userInfo:this.$bk_getUserInfo(),
				showPage:'',
			};
		},
		computed:{
			formConfig (){
				let minDate = new Date('1920', '01', '01');
				let maxDate = new Date();

				return {
					// required:true,
					items:[
						{e:'upload', langCode:'userInfo_personal_profile', key:'avatar', maxCount: 1},
						{e:'input', langCode:'userInfo_personal_firstName', key:'firstName' },
						{e:'input', langCode:'userInfo_personal_lastName', key:'lastName' },
						{e:'slot', langCode:'userInfo_personal_emailAddress', key:'email' },
						{e:'phone', langCode:'userInfo_personal_mobile', key:'mobile', dataList: this.dictInfo.intMobileCd },
						{e:'date', langCode:'userInfo_personal_birthday', key:'birthday', maxDate, minDate },
						{e:'select', langCode:'userInfo_personal_gender', key:'gender', dataList: this.genderList },
					]
				};
			}
		},
		mounted (){
			this.initData();
		},
		methods:{
			async initData (){

				// 数据字典
				let res = await baseReq.requestPostDictByTypeCode(this, ['intMobileCd']);
			
				this.dictInfo = res;

				this.requestGetUserInfo();
			},
			reloadData (){
				this.requestGetUserInfo();
				this.requestGetUserInfoByToken();
			},
			setShowPage (showPage=''){
				this.showPage = showPage;
			},
			async requestGetUserInfo (){
				this.loadView = 'view';

				const res = await authReq.requestGetUserInfo(this, {id: this.userInfo.userId });

				if(res.avatar){
					res.avatar = [{url: res.avatar}];
				}
				
				this.loadView = '';
				this.formData = res;
			},
			async requestGetUserInfoByToken (){
				let userInfo = await authReq.requestGetUserInfoByToken(this, {});
				userInfo.id = userInfo.id || userInfo.userId;
				this.$bk_setUserInfo(userInfo);
			},
			// 处理提交参数
			getSubmitParams (){
				const params = {
					...this.formData, 
				};

				if(params.avatar?.length){
					params.avatar = params.avatar[0].url;
				}else {
					params.avatar='';
				}
				return params;
			},
		
			// 提交
			async handleSave (){

				if(!await this.$refs.bkForm.validator()){
					return false;
				}
				

				const params = this.getSubmitParams();

				this.loadView = 'save';

				authReq.requestPostUserInfoUpdate(this, params).then(() => {
					this.$bk_message.success({ langCode:'global_msg_saveSuccessfully'});
					this.loadView = '';
					this.requestGetUserInfoByToken();
				}).catch(() => {
					this.loadView = '';
				});

			}
		}
		
	};
</script>

<style lang="less">
@import './personal.less';
</style>